import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const CalendarIcon: FC<IconProps> = ({ width = 35, height = 26, ...rest }) => (
  <Icon type="Calendar" width={width} height={height} alt="CalendarIcon" {...rest} />
)
